import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import { addG2T } from "../../../store/reducers/guestsReducer";

const AddG2T = ({ init, handleGetAll }) => {
  const dispatch = useDispatch();
  const [table, setTable] = useState(null);

  const { guestsLoading } = useSelector((state) => state.guestsReducer);
  const { user } = useSelector((state) => state.authReducer);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const body = {
      ...data,
      table: parseInt(table),
      seatupEventId: "besimple",
      sum: data.arrived,
      closeness: "הושבה",
      accept: data.arrived,
    };

    if (
      user.tablesArray[parseInt(table) - 1] == undefined ||
      parseInt(table) == 0 ||
      table == null ||
      user.tablesArray[parseInt(table) - 1].title == "רזרבה"
    )
      toast.warn("שולחן רזרבה/לא קיים - לא ניתן להושיב");
    else {
      console.log("body ", body);
      dispatch(addG2T(body)).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          handleGetAll();
          init();
        } else toast.error(res.payload?.error);
      });
    }
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <FlexRowBetween>
          <div style={{ width: "35%" }}>
            <Label>שם</Label>
            <Input
              type="text"
              {...register("name", {
                required: true,
                minLength: 2,
                maxLength: 20,
              })}
            />
            {CFV("name", "בין 2 ל 20 תווים", errors)}
          </div>
          <div style={{ width: "20%" }}>
            <Label>הגיעו</Label>
            <Input
              type="number"
              {...register("arrived", {
                required: true,
                min: 1,
                max: 15,
              })}
            />
            {CFV(`arrived`, `מספר בין 1 ל 15`, errors)}
          </div>
          <div style={{ width: "20%" }}>
            <Label>מס׳ שולחן</Label>
            <Input
              type="number"
              min={0}
              max={parseInt(user.tablesArray.length) - 1}
              onChange={(e) => setTable(e.target.value)}
              // style={{ padding: "2px 3px", margin: "0 8px" }}
            />
            <div style={{ height: "20px" }} />
            {/* <Input
            type="number"
            {...register("table", {
              required: true,
              min: 1,
              max: parseInt(user.tablesArray.length) - 1,
            })}
          />
          {CFV(
            `table`,
            `מספר בין 1 ל ${parseInt(user.tablesArray.length) - 1}`,
            errors
          )} */}
          </div>
        </FlexRowBetween>
        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>הוספה</Button>
        </FlexRowBetween>
      </div>

      {guestsLoading && <OpacityLoading />}
    </PopupForm>
  );
};

export default AddG2T;
